import script from "./AppStartModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AppStartModal.vue?vue&type=script&setup=true&lang=js"

import "./AppStartModal.vue?vue&type=style&index=0&id=06fb13ff&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06fb13ff"]])

export default __exports__